import React, { useCallback } from "react";
import Map, { Marker } from "react-map-gl/maplibre";
import "maplibre-gl/dist/maplibre-gl.css";

const MapComponent = ({ latitude, longitude, setLatitude, setLongitude }) => {
  const handleMapClick = useCallback(
    (event) => {
      const { lng, lat } = event.lngLat;
      if (lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
        setLatitude(lat);
        setLongitude(lng);
      }
    },
    [setLatitude, setLongitude]
  );

  return (
    <Map
      initialViewState={{
        latitude: latitude || 37.7749,
        longitude: longitude || -122.4194,
        zoom: 10,
      }}
      style={{ width: "100%", height: "100%" }}
      mapStyle="https://basemaps.cartocdn.com/gl/positron-gl-style/style.json"
      onClick={handleMapClick}
    >
      {latitude !== null && longitude !== null && (
        <Marker latitude={latitude} longitude={longitude} color="red" />
      )}
    </Map>
  );
};

export default MapComponent;
